module.exports = __webpack_public_path__ + "static/media/deciduous-tree-icon.e776409a.png";